import { stepsGuide } from "@/mocks/comics";

export default function EntryGuide() {
  return (
    <section id="entry" className="mx-auto max-w-page px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-2xl text-center">
        <span className="inline-block rounded-full bg-primary-100 px-4 py-1.5 text-xs font-bold text-primary-700 md:text-sm">
          免费版入口
        </span>
        <h2 className="mt-4 font-heading text-2xl md:text-4xl">三步开启你的免费阅读之旅</h2>
        <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
          无需任何付费，按照下面三步就能直达虫虫漫画免费版，从今天起想看的漫画随便看。
        </p>
      </div>

      <div className="mt-10 grid gap-4 md:mt-12 md:grid-cols-3 md:gap-6">
        {stepsGuide.map((step, index) => (
          <article
            key={step.title}
            className="relative rounded-2xl border border-background-200 bg-background-50 p-6 md:p-8"
          >
            <span className="absolute right-5 top-4 font-heading text-4xl text-background-200 select-none">
              {index + 1}
            </span>
            <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-500 text-background-50">
              <i className={`${step.icon} text-2xl`}></i>
            </span>
            <h3 className="mt-5 text-lg font-bold">{step.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-700">{step.desc}</p>
          </article>
        ))}
      </div>

      <div className="mt-8 flex flex-col items-center gap-4 rounded-2xl bg-primary-500 p-6 text-center text-background-50 md:mt-10 md:flex-row md:justify-between md:px-10 md:text-left">
        <div>
          <h3 className="font-heading text-lg md:text-xl">点击右侧按钮，即刻进入免费版阅读</h3>
          <p className="mt-1 text-xs text-background-100 md:text-sm">
            电脑、平板、手机都能用，登录后书架与进度自动同步。
          </p>
        </div>
        <a
          href="#top"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm font-bold text-primary-600 transition-colors hover:bg-background-100"
        >
          <i className="ri-arrow-right-circle-line text-lg"></i>
          打开免费版入口
        </a>
      </div>
    </section>
  );
}